const quantityInputStyle = () => `<style>
    input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        input[type="number"] {
            -moz-appearance: textfield;
        }
    .cart-quantity-container {
    display: flex;

    .quantity-button {
        border: 1px solid #ccc !important;
        color: #000;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 32px;
        font-weight: 700;
        text-align: center;
    }

    .quantity-button-minus {
        border-bottom-left-radius: 11px;
        border-right: none !important;
        border-top-left-radius: 11px;
        padding: 0;
        width: 35px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .quantity-input {
        display: inline-flex;
        max-height: none;
        border-top: 1px solid #ccc !important;
        border-bottom: 1px solid #ccc !important;
        border-left: 0px !important;
        border-right: 0px !important;
        width: 90px;
        min-width: auto !important;
        text-align: center;
        color: #000;
        z-index: 1;
        font-size: 14px !important;
        background: #ffffff;
        border-radius: 0 !important;
    }

    .quantity-button-plus {
        border-bottom-right-radius: 11px;
        border-left: none !important;
        border-top-right-radius: 11px;
        padding: 0;
        width: 35px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 768px) {
       .quantity-input {
          width: 32px;
       }
    }
    }</style>`;

export default quantityInputStyle;
